// import { Dom, Event, Text, Type } from 'main.core';
// import LazyLoader from './lazy-loader';

export default class ProductBonusProgram {
    defaultOptions: Object

    constructor(params) {
        this.ID = params.ID
        this.SORT = params.SORT
        this.XML_ID = params.XML_ID
        this.NAME = params.NAME
        this.CODE = params.CODE
        this.DESCRIPTION = params.DESCRIPTION
        this.HELP = params.HELP
        this.IMAGE = params.IMAGE
    }
}
